var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{viewBtnAssinar:_vm.btnActive},attrs:{"id":"btns-assine"}},[_vm._m(0),_c('router-link',{attrs:{"to":"/login"}},[_c('button',[_vm._v("Já sou assinante")])])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"#planos"}},[_c('button',{staticClass:"assine"},[_vm._v("Assine para ver conteúdo completo")])])
}]

export { render, staticRenderFns }